import {Driver, Vehicle} from 'types';
import styles from './WorkerSelect.module.scss';
import {get} from 'lodash';
import classNames from 'classnames';
import Individual from './Individual';
import Team from './Team';

type Props = {
  teams: Vehicle[];
  workers: Driver[];
  selectedWorker: Driver | Vehicle;
  onSelectWorker: (val: Vehicle | Driver) => void;
};

function WorkerSelect({teams, workers, selectedWorker, onSelectWorker}: Props) {
  const isIndividual = !!selectedWorker && 'driver_id' in selectedWorker;
  const assignedWorkerOrTeam = isIndividual
    ? (selectedWorker as Driver)
    : (selectedWorker as Vehicle);
  const selectedId = isIndividual
    ? selectedWorker?.driver_id
    : selectedWorker?.id;
  return (
    <div className={styles.teams}>
      <div className={classNames(styles.selectContainer, 'assign-team')}>
        <Individual
          selectedId={isIndividual ? selectedId : undefined}
          value={
            isIndividual
              ? {
                  label:
                    get(assignedWorkerOrTeam, 'first_name', '') +
                    ' ' +
                    get(assignedWorkerOrTeam, 'last_name', ''),
                  //@ts-ignore
                  value: assignedWorkerOrTeam?.driver_id,
                }
              : null
          }
          options={
            workers?.map((item) => ({
              ...item,
              label: item?.name,
              value: item?.driver_id,
            })) as any
          }
          onChange={onSelectWorker}
        />
        <Team
          selectedId={!isIndividual ? selectedId : undefined}
          value={
            !isIndividual && assignedWorkerOrTeam
              ? {
                  label: assignedWorkerOrTeam?.name,
                  value: assignedWorkerOrTeam?.id,
                }
              : null
          }
          options={
            teams?.map((item) => ({
              ...item,
              label: item.name,
              value: item?.id,
            })) as any
          }
          onChange={onSelectWorker}
        />
      </div>
    </div>
  );
}

export default WorkerSelect;
